import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconReport = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M7.25 12C7.25 11.5858 7.58579 11.25 8 11.25H16C16.4142 11.25 16.75 11.5858 16.75 12C16.75 12.4142 16.4142 12.75 16 12.75H8C7.58579 12.75 7.25 12.4142 7.25 12Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8 15.25C7.58579 15.25 7.25 15.5858 7.25 16C7.25 16.4142 7.58579 16.75 8 16.75H16C16.4142 16.75 16.75 16.4142 16.75 16C16.75 15.5858 16.4142 15.25 16 15.25H8Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M16.7323 3.25H17.7111C19.295 3.25 20.75 4.38965 20.75 6.00324V19.0043C20.7339 20.6078 19.2889 21.75 17.7111 21.75H6.28888C4.70503 21.75 3.25 20.6104 3.25 18.9968V6.00324C3.25 4.38965 4.70503 3.25 6.28888 3.25H7.26772C7.38903 2.40193 8.11838 1.75 9 1.75H15C15.8816 1.75 16.611 2.40193 16.7323 3.25ZM7.26772 4.75H6.28888C5.3394 4.75 4.75 5.39965 4.75 6.00324V18.9968C4.75 19.6003 5.3394 20.25 6.28888 20.25H17.7111C18.6429 20.25 19.2418 19.6051 19.25 18.9924V6.00324C19.25 5.39965 18.6606 4.75 17.7111 4.75H16.7323C16.611 5.59807 15.8816 6.25 15 6.25H9C8.11838 6.25 7.38903 5.59807 7.26772 4.75ZM8.75 3.5C8.75 3.36193 8.86193 3.25 9 3.25H15C15.1381 3.25 15.25 3.36193 15.25 3.5V4.5C15.25 4.63807 15.1381 4.75 15 4.75H9C8.86193 4.75 8.75 4.63807 8.75 4.5V3.5Z",
			fill: "currentColor"
		})
	]
});
export { SvgIconReport as ReactComponent };
